(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          setupCardSwiping();
          setupSlider();
          setupScrollTrack();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  function setupCardSwiping() {
    const swipeTracks = document.querySelectorAll('#complementaryProducts .card-product--image-swipe-track');
    swipeTracks.forEach((swipeTrack) => {
      const leftArrow = swipeTrack.closest('.card-product--image-swipe-container').querySelector('.pcpa-left');
      const rightArrow = swipeTrack.closest('.card-product--image-swipe-container').querySelector('.pcpa-right');
      const paginationBullets = swipeTrack
        .closest('.card-product--image-swipe-container')
        .querySelectorAll('.product-card--pagination-bullet');

      const updateArrowState = () => {
        const maxScrollLeft = swipeTrack.scrollWidth - swipeTrack.clientWidth;
        if (swipeTrack.scrollLeft <= 0) {
          leftArrow.classList.add('faded');
        } else {
          leftArrow.classList.remove('faded');
        }

        if (swipeTrack.scrollLeft >= maxScrollLeft - 2) {
          rightArrow.classList.add('faded');
        } else {
          rightArrow.classList.remove('faded');
        }
      };

      const updatePagination = () => {
        const scrollLeft = swipeTrack.scrollLeft;
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        const activeIndex = Math.round(scrollLeft / slideWidth) + 1;

        paginationBullets.forEach((bullet) => {
          if (parseInt(bullet.dataset.value, 10) === activeIndex) {
            bullet.classList.add('active');
          } else {
            bullet.classList.remove('active');
          }
        });
      };

      const onScroll = () => {
        updateArrowState();
        updatePagination();
      };

      swipeTrack.addEventListener('scroll', onScroll);

      leftArrow.addEventListener('click', () => {
        event.preventDefault(); // Prevent the link's default behavior
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        swipeTrack.scrollBy({
          left: -slideWidth,
          behavior: 'smooth',
        });
      });

      rightArrow.addEventListener('click', () => {
        event.preventDefault(); // Prevent the link's default behavior
        const slideWidth = swipeTrack.querySelector('.card-product--image-slide')?.clientWidth || 1;
        swipeTrack.scrollBy({
          left: slideWidth,
          behavior: 'smooth',
        });
      });

      // Initialize states
      updateArrowState();
      updatePagination();
    });
  }

  function setupSlider() {
    const sliderWrapper = document.querySelector('#complementaryProducts .comp-products-grid-wrapper');
    const sliderContainer = document.querySelector('#complementaryProducts .comp-products-grid');
    const leftArrow = document.querySelector('#complementaryProducts .slider-arrow-left');
    const rightArrow = document.querySelector('#complementaryProducts .slider-arrow-right');

    if (!sliderContainer || !leftArrow || !rightArrow) return;

    const setArrowState = () => {
      const scrollPosition = sliderContainer.scrollLeft;
      const containerWidth = sliderContainer.clientWidth;
      const totalWidth = sliderContainer.scrollWidth;
      const scrollLimit = totalWidth - containerWidth;

      // Find the first image element within the slider-grid
      const firstImage = sliderContainer.querySelector('img');
      
      // Get the height of the first image
      const imageHeight = firstImage ? firstImage.clientHeight : 0;

      // Apply top margin to arrows based on half of the image height
      if (sliderWrapper.classList.contains('slider-arrows-position-middle') && leftArrow && rightArrow && imageHeight !== 0) {
        const marginTop = (imageHeight * 0.5) - 24;
        leftArrow.style.marginTop = marginTop + 'px';
        rightArrow.style.marginTop = marginTop + 'px';
      }      
      
      if (scrollPosition <= 0) {
        leftArrow.classList.add('disabled');
      } else {
        leftArrow.classList.remove('disabled');
      }

      if (scrollPosition >= scrollLimit - 2) {
        rightArrow.classList.add('disabled');
      } else {
        rightArrow.classList.remove('disabled');
      }
    };

    setArrowState();

    sliderContainer.addEventListener('scroll', setArrowState);
    window.addEventListener('resize', setArrowState);

    function scrollToSnap(direction) {
      const items = sliderContainer.querySelectorAll('.grid__item');
      if (!items.length) return;

      const currentScroll = sliderContainer.scrollLeft;

      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - currentScroll);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      const targetIndex = Math.max(
        0,
        Math.min(items.length - 1, closestIndex + direction)
      );

      sliderContainer.scrollTo({
        left: items[targetIndex].offsetLeft,
        behavior: 'smooth',
      });
    }

    leftArrow.addEventListener('click', () => scrollToSnap(-1));
    rightArrow.addEventListener('click', () => scrollToSnap(1));
  }

  // Slider custom scrollbar

  function setupScrollTrack() {
    const wrapper = document.querySelector('#complementaryProducts .comp-products-grid-wrapper');
    if (wrapper) {
      const slider = wrapper.querySelector('#complementaryProducts .comp-products-grid');
      const track = wrapper.querySelector('.slider-custom-scrollbar-track');
      const marker = wrapper.querySelector('.slider-custom-scrollbar-marker');
    
      if (slider && track && marker) {
        function updateMarkerWidthAndVisibility() {
          const visibleWidth = slider.clientWidth;
          const scrollableWidth = slider.scrollWidth;
    
          if (scrollableWidth <= visibleWidth) {
            track.classList.add('hidden');
          } else {
            track.classList.remove('hidden');
            const trackWidth = track.clientWidth;
            const markerWidth = (visibleWidth / scrollableWidth) * trackWidth;
            marker.style.width = `${markerWidth}px`;
          }
        }
    
        function updateMarkerPosition() {
          const scrollLeft = slider.scrollLeft;
          const scrollableWidth = slider.scrollWidth - slider.clientWidth;
          const trackWidth = track.clientWidth - marker.clientWidth;
    
          const left = (scrollableWidth > 0) ? (scrollLeft / scrollableWidth) * trackWidth : 0;
          marker.style.transform = `translateX(${left}px)`;
        }
    
        // Initial setup
        updateMarkerWidthAndVisibility();
        updateMarkerPosition();
    
        // On scroll
        slider.addEventListener('scroll', updateMarkerPosition);
    
        // On window resize
        window.addEventListener('resize', () => {
          updateMarkerWidthAndVisibility();
          updateMarkerPosition();
        });
      }
    }
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["el-legacy-route"]) return;
  try {
    
(()=>{if(window.Shopify?.designMode)return;const route=document.querySelector('.el-legacy-route[data-destination]');if(route?.dataset.destination)window.location.replace(route.dataset.destination)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
 function chooseCare(a) {
  if (a.fragrance !== 'fine') return null;
  if (a.goal === 'hydration') return 'veil';
  if (a.goal === 'comfort') return a.skin === 'dry' ? 'nocturne' : 'veil';
  if (a.goal === 'radiance') return a.skin === 'dry' ? 'ether' : 'lumis';
  if (a.goal === 'renewal') return a.skin === 'oily' ? 'veil' : 'ether';
  return null;
 }
 function init(root) {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  const labels=JSON.parse(root.querySelector('[data-labels]').textContent);
  // Shopify escapes translations. Decode into a text node before assigning textContent.
  const decoder=document.createElement('textarea');
  Object.keys(labels).forEach(k=>{decoder.innerHTML=labels[k];labels[k]=decoder.value});
  const steps=[...root.querySelectorAll('[data-step]')], result=root.querySelector('[data-result]');
  const order=['goal','skin','fragrance'];let answers={},step=0;
  const progress=root.querySelector('[data-progress]'),back=root.querySelector('[data-back]');
  function show(focus=true){
   steps.forEach((node,i)=>node.hidden=i!==step);
   result.hidden=step!==3;back.hidden=step===0;progress.hidden=step===3;
   if(step<3){progress.textContent=labels.progress.replace('__NUMBER__',step+1);if(focus)steps[step].querySelector('h2').focus()}
  }
  function render(){
   const handle=chooseCare(answers),target=root.querySelector('[data-product-result]');target.replaceChildren();
   const template=handle?root.querySelector('template[data-product="'+handle+'"]'):null;
   root.querySelector('[data-contact]').hidden=Boolean(template);
   root.querySelector('[data-result-title]').textContent=handle?labels.result:labels.no_fit_title;
   root.querySelector('[data-reason]').textContent=handle?(template?labels['why_'+handle]:labels.missing):labels.no_fit;
   root.querySelector('[data-skin-note]').textContent=handle?labels['skin_'+answers.skin]:'';
   if(template)target.append(template.content.cloneNode(true));
   show(false);root.querySelector('[data-result-title]').focus();
  }
  root.querySelectorAll('[data-answer]').forEach(button=>button.addEventListener('click',()=>{
   if(button.dataset.question!==order[step])return;
   answers[button.dataset.question]=button.dataset.answer;step++;
   if(step===3)render();else show();
  }));
  back.addEventListener('click',()=>{if(step>0){step--;order.slice(step).forEach(k=>delete answers[k]);show()}});
  root.querySelector('[data-restart]').addEventListener('click',()=>{answers={};step=0;show()});
  root.querySelector('[data-fallback]').hidden=true;root.querySelector('[data-quiz]').hidden=false;show(false);
 }
 document.querySelectorAll('[data-care-finder]').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-care-finder]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-header"] && !Shopify.designMode) return;
  try {
    
(() => {
 const menu=document.getElementById('s-burger');
 if(!menu) return;
 const summary=menu.querySelector('summary');
 const close=menu.querySelector('.s-mnav__close');
 let previousOverflow='';
 const hide=()=>{menu.open=false;summary.focus()};
 close.addEventListener('click',hide);
 menu.addEventListener('toggle',()=>{if(menu.open){previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';close.focus()}else{document.body.style.overflow=previousOverflow}});
 menu.addEventListener('keydown',e=>{if(!menu.open)return;if(e.key==='Escape'){e.preventDefault();hide()}if(e.key==='Tab'){const items=[...menu.querySelectorAll('nav a,nav button,nav select')].filter(x=>!x.disabled&&x.getClientRects().length);if(!items.length)return;const first=items[0],last=items.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});
 matchMedia('(min-width:900px)').addEventListener('change',e=>{if(e.matches)menu.open=false});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = (root) => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const gallery=root.querySelector('.el-product__gallery');
  const count=root.querySelector('[data-gallery-count]');
  if (gallery && count) {
   const slides=[...gallery.children];
   const move=(n)=>gallery.scrollBy({left:n*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   root.querySelector('[data-gallery-prev]').addEventListener('click',()=>move(-1));
   root.querySelector('[data-gallery-next]').addEventListener('click',()=>move(1));
   gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
   gallery.addEventListener('scroll',()=>{count.textContent=`${Math.round(gallery.scrollLeft/gallery.clientWidth)+1} / ${slides.length}`},{passive:true});
  }
  function revealIngredients(){if(location.hash==='#el-product-inci'){const summary=root.querySelector('#el-product-inci');if(summary)summary.closest('details').open=true}}
  revealIngredients();window.addEventListener('hashchange',revealIngredients);
  const form=root.querySelector('.el-product__form');
  const primary=form.querySelector('button');
  const bar=root.querySelector('.el-product__sticky');
  const sticky=bar.querySelector('button');
  const labels=JSON.parse(root.querySelector('.el-product__labels').textContent);
  const select=form.querySelector('select');
  if(select) select.addEventListener('change',()=>{const o=select.selectedOptions[0];const available=o.dataset.available==='true';[primary,sticky].forEach(b=>{b.disabled=!available;b.textContent=available?labels.add:labels.sold});root.querySelectorAll('[data-product-price]').forEach(n=>n.textContent=o.dataset.price)});
  if('IntersectionObserver' in window){new IntersectionObserver(entries=>{const entry=entries[0];bar.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>0;},{threshold:0}).observe(primary)}
 };
 document.querySelectorAll('.el-product').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.el-product').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
